import { ConfigProvider, Layout, Menu } from "antd";
import { useEffect, useRef, useState } from "react";
import { Logo } from "../Logo/Logo";

import { COLOR } from "../../App";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { PATH_LANDING } from "../../constants/routes";

const { Sider } = Layout;
export const SideNav = ({ ...props }) => {
  const nodeRef = useRef(null);
  const { paths } = useSelector((state) => state.auth);
  const { pathname } = useLocation();
  const [openKeys, setOpenKeys] = useState([""]);
  const [current, setCurrent] = useState("");
  const [items, setItems] = useState([]);
  const [subMenuKeys, setSubMenuKeys] = useState([]);

  useEffect(() => {
    setItems(paths?.menu_items);
    setSubMenuKeys(paths?.submenu_keys);
  }, [paths]);
  useEffect(() => {
    const paths = pathname.split("/");
    setOpenKeys(paths);
    setCurrent(paths[paths.length - 1]);
  }, [pathname]);

  const onOpenChange = (keys) => {
    const latestOpenKey = keys.find((key) => openKeys.indexOf(key) === -1);
    if (latestOpenKey && subMenuKeys.indexOf(latestOpenKey) === -1) {
      setOpenKeys(keys);
    } else {
      setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
    }
  };
  return (
    <Sider ref={nodeRef} breakpoint="lg" collapsedWidth="0" {...props}>
      <Logo
        color="blue"
        asLink
        href={PATH_LANDING.root}
        justify="center"
        gap="small"
        imgSize={{ h: 45, w: 45 }}
        style={{ padding: "8px 0" }}
      />
      <ConfigProvider
        theme={{
          components: {
            Menu: {
              itemBg: "none",
              itemSelectedBg: COLOR["100"],
              itemHoverBg: COLOR["50"],
              itemSelectedColor: COLOR["600"],
            },
          },
        }}
      >
        <Menu
          mode="inline"
          items={items}
          openKeys={openKeys}
          onOpenChange={onOpenChange}
          selectedKeys={[current]}
          style={{ border: "none" }}
        />
      </ConfigProvider>
    </Sider>
  );
};
